import { memo } from 'react';
import { TagList } from '@dfl/mui-react-common';

type ProviderFieldFixedValuesCellProps = {
  value: string[];
};

const ProviderFieldFixedValuesCell = ({ value }: ProviderFieldFixedValuesCellProps) => {
  if (!value?.length) return null;
  return <TagList value={value} limit={3} />;
};

export default memo(ProviderFieldFixedValuesCell);
